export default "__VITE_ASSET__CroTxEs___"